import { render, staticRenderFns } from "./BannerAula.vue?vue&type=template&id=923df0e8&scoped=true"
import script from "./BannerAula.vue?vue&type=script&lang=js"
export * from "./BannerAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923df0e8",
  null
  
)

export default component.exports